import ImageAvatar from 'ComponentLibrary/src/atoms/Avatar/ImageAvatar'
import { Box } from '@mui/material'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { UserCircle, UserCircleDashed } from '@phosphor-icons/react'
import { defaults } from 'lodash'

type UserBubbleProps = {
    profileImageUrl?: string
    profileFallbackImageUrl?: string
    size?: `${number}px`
    defaultIconCustomColors?: Partial<{ bgColor: string; color: string }>
    defaultIconVariant?: 'default' | 'unavailable'
}

export const UserBubble = ({
    profileImageUrl,
    profileFallbackImageUrl,
    size = tokens.SizingIconM,
    defaultIconCustomColors,
    defaultIconVariant = 'default',
}: UserBubbleProps) => {
    if (profileImageUrl) {
        return <ImageAvatar imageUrl={profileImageUrl} fallbackImageUrl={profileFallbackImageUrl} size={size} />
    }

    const { bgColor, color } = defaults({}, defaultIconCustomColors, {
        color: tokens.ColorGraphSequentialOneMedium,
        bgColor: tokens.ColorGraphSequentialOneLightest,
    })

    return (
        <Box
            borderRadius={tokens.SizingCornerRound}
            height={size}
            width={size}
            display="flex"
            alignItems="center"
            justifyContent="center"
            bgcolor={bgColor}
        >
            {defaultIconVariant === 'unavailable' ? (
                <UserCircleDashed weight="bold" size={`calc(${size} * 0.75)`} color={color} />
            ) : (
                <UserCircle weight="bold" size={`calc(${size} * 0.75)`} color={color} />
            )}
        </Box>
    )
}
